/**
 * Configuration for the markdown editor toolbar.
 * @type {Array<Array<Object>>}
 */
export const toolbarConfig = [
  [{
    pre: '# ', isBlock: true, img: 'https://storage.googleapis.com/komerce/icon/align-right-icon.svg', cls: '!size-[18px]',
  },
  {
    pre: '## ', isBlock: true, img: 'https://storage.googleapis.com/komerce/icon/align-right-icon.svg', cls: '!size-[16px]',
  },
  {
    pre: '### ', isBlock: true, img: 'https://storage.googleapis.com/komerce/icon/align-right-icon.svg', cls: '!size-[14px]',
  }],
  [{ pre: '**', suf: '**', icon: 'BoldIcon' },
    { pre: '*', suf: '*', icon: 'ItalicIcon' },
    { pre: '<u>', suf: '</u>', icon: 'UnderlineIcon' }],
  [{ pre: '- ', isBlock: true, icon: 'ListIcon' },
    {
      pre: '1. ', isBlock: true, img: 'https://storage.googleapis.com/komerce/icon/ordered-list-icon.svg',
    }],
  [{ pre: '```\n', suf: '\n```', img: 'https://storage.googleapis.com/komerce/icon/code-block-icon.svg' },
    {
      pre: '> ', isBlock: true, label: '', cls: 'k-quote-down text-[#A0A0A0]',
    }],
  [{
    pre: '| Column 1 | Column 2 |\n| -------- | -------- |\n| Text     | Text     |',
    isBlock: true,
    img: 'https://storage.googleapis.com/komerce/icon/table.svg',
  },
  { image: true, img: 'https://storage.googleapis.com/komerce/icon/image-plus.svg' },
  { pre: '[Link Text](', suf: ')', cls: 'k-link' }],
]

/**
 * Toast messages for article submission status.
 * @type {Object}
 */
export const ARTICLE_SUBMIT_MESSAGE = {
  success: {
    draft: 'Draft disimpan!',
    publish: 'Artikel di-publish!',
    hide: 'Artikel disembunyikan!',
  },
  failed: {
    draft: 'Gagal menyimpan draft',
    publish: 'Gagal mem-publish artikel',
    hide: 'Gagal menyembunyikan artikel',
  },
}
